import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RelatiesService } from 'src/app/shared/dataservices/relaties.service';
import {AfleverAdres, FactuurAdres} from 'src/app/shared/model/relatie'


export interface AdresSelectData {
  relatieid: number;
  adresid: number;
}

@Component({
  selector: 'app-select-adres',
  templateUrl: './select-adres.component.html',
  styleUrls: ['./select-adres.component.less']
})
export class SelectAdresComponent implements OnInit {

  adressen : Array<FactuurAdres>

  constructor(
    public dialogRef: MatDialogRef<SelectAdresComponent>,
    public relatieService : RelatiesService,
    @Inject(MAT_DIALOG_DATA) public data: AdresSelectData
    ) { }

  ngOnInit(): void {
      this.relatieService.getFactuurAdressen(this.data.relatieid).subscribe( adressen => {
        this.adressen = adressen;
        console.log(this.adressen)
      })
  }

  selectAdres(id: number) {
    this.data.adresid = id;
    this.dialogRef.close(this.data);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
